import { render, staticRenderFns } from "./EsamiSpecialisticiViewComponent.vue?vue&type=template&id=2ca1ed0f"
import script from "./EsamiSpecialisticiViewComponent.vue?vue&type=script&lang=js"
export * from "./EsamiSpecialisticiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports